import { type FC } from 'react';
import { Provider } from 'react-redux';
import { type Store } from 'redux';
import { useLazyLoadQuery, graphql } from 'react-relay';
import { type Locale } from 'dibs-intl/exports/locales';
import { type DEVICE_TYPES } from 'dibs-buyer-layout/exports/deviceTypeEnums.ts';
import { IntlProvider } from 'dibs-react-intl';
import { DibsWeb3ReactProvider } from 'dibs-crypto-utils/exports/DibsWeb3ReactProvider.ts';

import { CREATORS } from '../nftHeader/pageType.ts';
import { NftHeaderLayout } from '../nftHeader/NftHeaderLayout.tsx';
import { NftCreatorsLayout } from './NftCreatorsLayout.tsx';
import {
    type NftCreatorsWrapperQuery,
    type NftCreatorsWrapperQuery$variables,
} from './__generated__/NftCreatorsWrapperQuery.graphql.ts';

type Props = {
    locale: Locale;
    deviceType: DEVICE_TYPES;
    store: Store;
    variables: NftCreatorsWrapperQuery$variables;
};

export const NftCreatorsWrapper: FC<Props> = ({ locale, store, variables, deviceType }) => {
    const data = useLazyLoadQuery<NftCreatorsWrapperQuery>(
        graphql`
            query NftCreatorsWrapperQuery($pageId: String = "", $creatorsItemCount: Int = 80) {
                viewer {
                    ...NftCreatorsLayout_viewer
                    ...NftHeaderLayout_viewer
                }
            }
        `,
        variables
    );
    return (
        <IntlProvider locale={locale} disableTranslations>
            <DibsWeb3ReactProvider>
                <Provider store={store}>
                    <NftHeaderLayout
                        viewer={data.viewer}
                        isNftLandingPage
                        serverDeviceType={deviceType}
                        initialPageType={CREATORS}
                    >
                        <NftCreatorsLayout viewer={data.viewer} />
                    </NftHeaderLayout>
                </Provider>
            </DibsWeb3ReactProvider>
        </IntlProvider>
    );
};
